<app-menu></app-menu>
<mat-toolbar class="flexSpace" color="primary">
  Test LCDV to Dynamic Image Set Id mapping

  <button
    [ngClass]="selectedClass"
    mat-flat-button
    [matMenuTriggerFor]="testAreas"
  >
    {{ selectedTestArea.toString() }}
  </button>
  <mat-menu style="display: flex; flex-direction: column" #testAreas="matMenu">
    <button
      *ngIf="user.hasEmbargoPermissions()"
      class="embargo"
      mat-menu-item
      (click)="selectTestArea(testArea.EMBARGO)"
    >
      {{ testArea.EMBARGO.toString() }}
    </button>
    <button
      class="pre-prod"
      mat-menu-item
      (click)="selectTestArea(testArea.PREPROD)"
    >
      {{ testArea.PREPROD.toString() }}
    </button>
    <button class="prod" mat-menu-item (click)="selectTestArea(testArea.PROD)">
      {{ testArea.PROD.toString() }}
    </button>
  </mat-menu>
</mat-toolbar>

<div style="margin: auto">
  <mat-card>
    <mat-card-content>
      <mat-card class="mat-elevation-z0 card-padding">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="disId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Dynamic Image Set
              <div>
                <mat-form-field>
                  <input
                    matInput
                    class="form-field"
                    [formControl]="disFilter"
                    placeholder="search"
                  />
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let row">{{ row.disId }}</td>
          </ng-container>
          <ng-container matColumnDef="redirect">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Redirect</th>
            <td mat-cell *matCellDef="let row">
              <div *ngIf="row.redirectInfo; else elseDiv">
                <span
                  data-toggle="tooltip"
                  data-placement="top"
                  class="my-tooltip"
                  title="Target exterior layers: {{ row.redirectInfo.extLayerSourceDisId }}
Target exterior rules : {{ row.redirectInfo.extRulesSourceDisId }}
Target interior layers: {{ row.redirectInfo.intLayerSourceDisId }}
Target interior rules : {{ row.redirectInfo.intRulesSourceDisId }}"
                >
                  <mat-icon>info</mat-icon>
                </span>
              </div>
              <ng-template #elseDiv></ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="versionId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Version
              <div>
                <mat-form-field>
                  <input
                    matInput
                    class="form-field"
                    [formControl]="versionFilter"
                    placeholder="search"
                  />
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let row">{{ row.versionId }}</td>
          </ng-container>
          <ng-container matColumnDef="versionLabel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Version Name
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.versionLabel }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="5">No data matching the filters</td>
          </tr>
        </table>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>
